/* Auto-migrated entry point.
 * This file will be loaded after the application entry point.
 * Remove non-global components from the js/index.js file, and add them in this file.
 * The tags: `wle:auto-imports:start`, and `wle:auto-imports:end` can be used in this file */

/* wle:auto-imports:start */
import {ImageTexture} from '@wonderlandengine/components';
import {MouseLookComponent} from '@wonderlandengine/components';
import {WasdControlsComponent} from '@wonderlandengine/components';
import {WelcomeMessage} from './welcome-message.js';
/* wle:auto-imports:end */
export default function(engine) {
/* wle:auto-register:start */
engine.registerComponent(ImageTexture);
engine.registerComponent(MouseLookComponent);
engine.registerComponent(WasdControlsComponent);
engine.registerComponent(WelcomeMessage);
/* wle:auto-register:end */
}

